import React from 'react';

import Textfield from '@atlaskit/textfield';

export default function TextFieldAppearanceStandard(): React.JSX.Element {
	return <Textfield appearance="standard" label="Standard" placeholder="" />;
}
